import script from "./noteSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./noteSlide.vue?vue&type=script&setup=true&lang=js"

import "./noteSlide.vue?vue&type=style&index=0&id=19e2030b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e2030b"]])

export default __exports__